import React, { useState, useEffect } from "react";
import MSMPagination from '../MSMPagination';
import Table from 'react-bootstrap/Table';

import DecoratorService from "../../services/decorator.service";
import DecoratorModal from "../modals/DecoratorModal";
import {Pencil, Diagram2, ArrowUpCircle, ArrowDownCircle, XCircle } from 'react-bootstrap-icons';
import Button from "react-bootstrap/Button";

const AdminDecorators = () => {
  const [ modalShow, setModalShow ] = useState(false);
  const [ decorators, setDecorators ] = useState([]);
  const [ currentDecorator, setCurrentDecorator ] = useState(null);

  const closeModal = async () => {
    const decorators = await DecoratorService.getDecorators();
    setDecorators(decorators);
    setModalShow(false);
  }

  const showModal = (decorator) => {
    console.log("Show Modal", decorator);
    setCurrentDecorator(decorator);
    setModalShow(true);
  }

  const deleteDecorator = async (decorator) => {
    console.log("Delete:", decorator.id);
    await DecoratorService.deleteDecorator(decorator.id);
    const decorators = await DecoratorService.getDecorators();
    setDecorators(decorators);
  }    

  const moveRow = (direction, decorator) => {
    console.log("Move:", direction, decorator.id);
    var newDecoratorList = [];
    var index = -1;
    for(var i=0; i<decorators.length; i++) {
        if(decorator.id === decorators[i].id) {
            index = i;
        }
    }
    
    if(direction) { //move up
        if(index == 0) return;
        newDecoratorList = [
            ...decorators.slice(0, index-1),
            decorators[index],
            decorators[index-1],
            ...decorators.slice(index+1)
        ];
    } else { // move down
        if(index == decorators.length-1) return;
        newDecoratorList = [
            ...decorators.slice(0, index),
            decorators[index+1],
            decorators[index],
            ...decorators.slice(index+2)
        ];
    }
    setDecorators(newDecoratorList);
    DecoratorService.updateDecoratorOrder(newDecoratorList);
}

  useEffect(() => {
    async function fetchData() {
        const decorators = await DecoratorService.getDecorators();
        setDecorators(decorators);
    }
    fetchData();   
  }, []);
  
  return (
    <div className="container">
         <h2>Decorators</h2>
         <Button onClick={() => showModal(null)}><Diagram2/ > Add Decorator</Button>
        { decorators && decorators.map(decorator => (
          <div className="user-list-item" key={decorator.id}>
            <div className="icon"><Diagram2 size={75}/></div>
            <div className="details">
              <span className="title">Name:</span> {decorator.name}<br/>
              <span className="title">Address:</span> <br/>
                {decorator.street}<br/>
                {decorator.street2 ? decorator.street2 : null}
                {decorator.city}, {decorator.state} {decorator.zip }<br/>
                <Button onClick={() => showModal(decorator)}><Pencil/ > Edit Decorator</Button>

            </div>
            <div>
              <a onClick={() => showModal(decorator)}><Pencil size={25} /> </a>
              <a onClick={() => {moveRow(true, decorator)}}><ArrowUpCircle size={25}/></a> 
              <a onClick={() => {moveRow(false, decorator)}}><ArrowDownCircle size={25}/></a>
              
              <a onClick={() => {deleteDecorator(decorator)}}><XCircle size={26} style={{marginLeft: 15, backgroundColor: "#FF9999", borderRadius: 13}} /></a>
            </div>
          </div>
        )) 
        }
        {modalShow && <DecoratorModal show={modalShow} closeModal={closeModal} decorator={currentDecorator} />}
    </div>
  );
};
export default AdminDecorators;
